<template>
  <div class="collection-options">
    <span class="py-3 hidden md:inline lg:inline">
      <p class="inline-block font-light pr-2 text-xs">Browse Collections</p>
      <div
        v-for="(collection, index) in collectionOptions"
        :key="collection.option_id"
        class="collection-options__item"
        :class="{
          'text-grey-md-dark':
            selectedCollection.field_id &&
            collection.option != selectedCollection.option,
        }"
      >
        <a
          class="cursor-pointer"
          @click="handleCollectionSelection(collection)"
        >
          &nbsp;
          {{
            collection.option.charAt(0).toUpperCase() +
              collection.option.slice(1)
          }}
          <a
            v-if="collection.option == selectedCollection.option"
            class="cursor-pointer"
          >
            <svg
              class="icon cursor-pointer icon-close w-2 h-2"
              aria-hidden="true"
              focusable="false"
            >
              <use xlink:href="#icon-close" />
            </svg>
          </a>
        </a>
        <span v-if="index !== collectionOptions.length - 1">&nbsp; /</span>
      </div>
    </span>
    <div
      class="search-box select-collection bg-grey-accent md:hidden lg:hidden flex justify-between"
    >
      <select
        id="collection-select"
        placeholder="Paceholder"
        class="global-nav__search-input addsearch text-base plp-hero__dropdown--mobile"
        @change="handleCollectionSelection($event)"
      >
        <option value="" selected>
          Browse Collections
        </option>
        <option
          v-for="(collection, index) in collectionOptions"
          :key="collection.option_id"
          :value="index"
          :selected="collection.option === selectedCollection.option"
        >
          {{
            collection.option.charAt(0).toUpperCase() +
              collection.option.slice(1)
          }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../shared/event-bus';

export default {
  props: {
    collectionOptions: Array,
    selectedCollection: Object,
  },
  mounted() {},
  methods: {
    handleCollectionSelection(newSelectedCollection) {
      if (newSelectedCollection.option == this.selectedCollection.option) {
        eventBus.updateSelectedCollection({
          option: '',
          field_id: '',
          option_id: '',
        });
      } else if (newSelectedCollection['field_id']) {
        eventBus.updateSelectedCollection(newSelectedCollection);
      } else {
        eventBus.updateSelectedCollection(
          this.collectionOptions[newSelectedCollection.target.value]
        );
      }
    },
  },
};
</script>
